module.exports = __webpack_public_path__ + "static/img/commodity_back_new.de9a7a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commodity_back_new.png
// module id = oA+P
// module chunks = 128